var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 17,
    viewBox: "0 0 57 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.132324,
    width: 56,
    height: 16.8675,
    fill: "url(#pattern0_385_5003)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_385_5003",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_385_5003",
    transform: "matrix(0.0172414 0 0 0.0572414 0 -0.0437931)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_385_5003",
    width: 58,
    height: 19,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADoAAAATCAMAAAD2xu7kAAACc1BMVEUAAAAAgIAAv78Av78XubkMtrYKuLgJv78Qt78OuroMvLwOub4Nvb0Nub0Mu7sMur0MvLwLu70Lu7sLvLwNu7sMu7sLurwLu70Mu7sLvLwMu7wMvLwMu7wMu70Mu7wMu7wMu7wNu7wMu7wLvLwNu7wMu7wMu7wMu7wMu70Mu7wMvLwMu7wMu7wMu7wMu7wMu7wMu7wMu7wNu7wOvL0PvL0QvL0RvL0Svb4Tvb4Uvb4Vvb4Wvr8Xvr8Yvr8Zv8Aav8Abv8AcwMAdwMEewMEfwMEgwcIhwcIjwcIkwsMlwsMow8Qpw8QtxMUuxcUwxcYxxcYyxsc0xsc2x8g3x8g5yMg6yMk9yck+yco/ycpAyspGy8xHzMxIzM1Lzc1Mzc5Nzc5Ozc5Uz9BW0NBX0NFa0dJc0dJd0tJf0tNh09Nj09Rn1NVn1dVq1dZs1tdt1tdu1tdw19hy2Nh02Nl12Nl22dl32dl42dp52dp62tp72tt929t+29yA3NyC3N2D3N2E3d2J3t6K3t+M39+O3+CP4OCQ4OCQ4OGR4OGS4eGU4eKV4eKW4uKZ4uOb4+Oc4+Sd5OSg5OWh5eWj5eam5uen5uep5+eu6Omx6emy6eqz6uq46+u57Oy67Oy77Oy87O297e3A7e7B7u7D7u7E7u/H7+/J8PDK8PDL8PHM8fHN8fHO8fLP8vLQ8vLR8vLU8/PV8/PY9PTZ9PTa9fXb9fXc9fXf9vbg9vbh9vfh9/fi9/fj9/fk+Pjl+Pjm+Pjn+Pjo+fnp+fnr+fnu+vrw+/vx+/vz/Pz0/Pz1/Pz2/f33/f34/f35/f37/v78/v79/v7+//////9dK3VFAAAAMXRSTlMAAgQICxUZHCAlKjc6TVJVanBxcnWAhoePn6SqrK27wsPK3N/g4eTn6uvu8vX2+f3+TTKjjgAAAAFiS0dE0A7Wz5wAAAIRSURBVBgZncH3WwxwAMfxrz2zyt4jo6x3kpRVUSEjI1l3QodwlKisiIaRSF1G2btQkT0jSuvzJ7mr5/E8PE8/nNfLGNN3nI97Jg5ub1p0nY7b+pkWHrjPt4tx6cN/GGZcBvI/PIzTEGCb49TJxw+TYEHqrYrK/MURDscGCHc4Ygodmy8+u7Fsy7XyvCCwFjwpyw7BybujMWYkcFZqapD2sFuqk8pmfFYOpKsqUmr+Ln3TDymRw9Iv6Z4fTgOMMWOBqyqeO79Uj7BY5rFDirqsBwR+1t5YyUqh3q6cWaXTyxt1YEZ0raw4Te1u2k0FypQGKaomOKHg5m1p1S7VByXozSybqiFPV+C5UtP01WazvdVBXEaYzjhVywZH9HFhpRpefZCWhjdp41PtJ02lUKIzUKP482q1Dxdf0wOYJ8XCXRUd06sILGrwp1Qleh9IroqgQsmESeuO6lsYf/Q3vYHVUtL6XDVvyNLL2Lj7eg0ZkpLgunLwq9U2YqRFaxr1ImV35iVchrYznkCcXBpTWVsn6Z3uwCbp02woVxIR0lq26yfsrZdTPk6jOhgzCEhUxdas46uAFenZlli7FSKlQ0CCPYpQuz2YaPtOYEnyuRPxAcCYTsaY4UCmivlHhr4E06ZJ3YzTaMChC/wttEZptGlKT+MyAZgTEsTfAkJC/GnLtF6mxWTc5mlaeY33cY+3l2n1G1CIVgI1548LAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayme);
export default __webpack_public_path__ + "static/media/payme.0441413efbefc3063b90a050d0991060.svg";
export { ForwardRef as ReactComponent };